import styled from 'styled-components'
import { space, layout } from 'styled-system'

const CardButton = styled.button`
  display: flex;
  border-radius: 12px;
  flex-direction: column;
  width: 100%;
  cursor: pointer;
  transform: translate(0, 0);
  box-shadow: 4px 6px 0 #00000026;
  padding: 0;

  ${layout}
  ${space}

  transition: transform 0.2s, box-shadow 0.2s;

  &:hover:not(:disabled) {
    transform: translate(-2px, -2px);
    box-shadow: 6px 8px 0 #00000026;
  }
  &:active:not(:disabled) {
    transform: translate(2px, 2px);
    box-shadow: 2px 4px 0 #00000026;
  }
`

export default CardButton
